import React, { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { FormDatePicker } from "go-form/components/FormDatePicker";
import { CustomValidationConfig, CustomValidationConstraint, CustomValidationError } from "go-form/services/types";
import { OrderShipApi } from "../../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<OrderShipApi>;
	setErrors: React.Dispatch<React.SetStateAction<CustomValidationError<OrderShipApi>[]>>;
}

const OrderShipBasicInfoForm = ({ form, setErrors }: Props) => {
	const {
		formState: { errors },
		control,
		register,
	} = form;
	const { t } = useTranslation();
	const orderedAtValidationConfig = useMemo(
		() => ({
			types: [{ constraint: CustomValidationConstraint.REQUIRED }],
			setErrors,
		}),
		[setErrors]
	) satisfies CustomValidationConfig;

	return (
		<>
			<h5>{t("common.word.basic_info")}</h5>
			<fieldset className="form-group">
				<div className="row">
					<div className="col-md-6">
						<FormDatePicker
							allowClear={false}
							errors={errors}
							control={control}
							name="shipped_at"
							label={t("modules.order.field.shipped_at.title")}
							customValidationConfig={orderedAtValidationConfig}
						/>
					</div>
					<div className="col-md-6">
						<FormInput
							name="reference_number"
							label={t("common.word.reference_number")}
							errors={errors}
							register={register}
						/>
					</div>
				</div>
			</fieldset>
		</>
	);
};

export default OrderShipBasicInfoForm;
